class RegisterModel {
    constructor(data) {
        this.id = data?.id;
        this.name = data?.name;
        this.email = data?.email;
        this.password = data?.password;
        this.password_confirmation = data?.password_confirmation;
        this.linkedin = data?.linkedin;
        this.country_id = data?.country_id;
        this.city_id = data?.city_id;
        this.position = data?.position;
        this.network = data?.network;
        this.company = data?.company;
        this.role_id = data?.role_id;
    }
}

export default RegisterModel;